import FlightAddToBasketModule from './flight-add-to-basket/flight-add-to-basket-module';
import FlightFareModule from './flight-fare/flight-fare-module';
import FlightSegmentModule from './flight-segment/flight-segment-module';

import FlightRecommendation from './flight-recommendation-component';
import FlightRecommendationService from './flight-recommendation-service';

const MODULE_NAME = 'app.flight.recommendation';
const module = angular.module(MODULE_NAME, [
        FlightSegmentModule,
        FlightAddToBasketModule,
        FlightFareModule,
    ])
    .directive(FlightRecommendation.DIRECTIVE_NAME, FlightRecommendation)
    .service('flightRecommendationService', FlightRecommendationService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-recommendation-module.js